export default "__VITE_ASSET__BZxeSn11__"